import { Injectable } from '@angular/core';
import { ArticleSearch } from 'projects/zbs-app/src/app/services/Ebootis.Queries/ArticleSearch';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ArticleSearchService {
	private m_lastArticleSearchParams: ArticleSearch.Params;
	private m_lastArticleSearchResults: ArticleSearch.Result;
	private m_lastViewedArticleOid: string;
	constructor(
		private m_articleSearch: ArticleSearch
	) { }

	public searchArticle(p_params: ArticleSearch.Params): Observable<ArticleSearch.Result> {
		this.m_lastArticleSearchParams = p_params;
		return this.m_articleSearch.query(p_params).pipe(tap((res) => this.m_lastArticleSearchResults = res));
	}
	public getLastSearchResults(): ArticleSearch.Result {
		return this.m_lastArticleSearchResults;
	}
	public getLastSearchParams(): ArticleSearch.Params {
		return this.m_lastArticleSearchParams;
	}

	public getLastViewedArticle(): string {
		return this.m_lastViewedArticleOid;
	}

	public setLastViewedArticle(p_articleOid: string): void {
		this.m_lastViewedArticleOid = p_articleOid;
	}

	public reset() {
		this.m_lastArticleSearchParams = null;
		this.m_lastArticleSearchResults = null;
		this.m_lastViewedArticleOid = null;
	}
}
